// extracted by mini-css-extract-plugin
export var container = "_cw-0";
export var popoverContent = "_cw-1";
export var tosLink = "_cw-2";